// adding some validations logic for subscribers form
import { required, email } from 'vuelidate/lib/validators'

export const FORM_SUBSCRIBERS_VALIDATIONS = {
  dataForm: {
    subscriberEmail: {
      required,
      email
    },
    subscriberUnsubscribed: {
      required
    }
  }
};



// WEBPACK FOOTER //
// ./src/validations/formSubscribers.js